/**
 *
 *
 *
 *
 */
export async function waitForCondition(conditionFn: (...args: unknown[]) => unknown | Promise<unknown>, pollingTime = 10): Promise<void> {
    while (true) {
        try {
            if (!!(await conditionFn())) {
                return;
            }
        } catch (_e) {}

        await new Promise(res => setTimeout(res, pollingTime));
    }
}
